import React, { useState } from 'react';
import apiService from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Mobile number validation - only digits, max 10
    if (name === 'mobile') {
      const mobileValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setFormData({
        ...formData,
        [name]: mobileValue
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate and trim all fields
    const nameValue = formData.name.trim();
    const emailValue = formData.email.trim();
    const mobileClean = formData.mobile.replace(/\D/g, '');
    const subjectValue = formData.subject.trim();
    const messageValue = formData.message.trim();
    
    // Validate required fields
    if (!nameValue || nameValue.length === 0) {
      alert('Please enter your full name');
      return;
    }
    
    if (!emailValue || emailValue.length === 0) {
      alert('Please enter your email address');
      return;
    }
    
    if (mobileClean.length !== 10) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }
    
    if (!messageValue || messageValue.length === 0) {
      alert('Please enter your message');
      return;
    }
    
    setLoading(true);

    // Prepare form data - API expects: full_name, mobile, subject, message, email
    const finalSubject = subjectValue || 'General Inquiry';
    
    const submitFormData = new FormData();
    submitFormData.append('full_name', nameValue);
    submitFormData.append('email', emailValue);
    submitFormData.append('mobile', mobileClean);
    submitFormData.append('subject', finalSubject);
    submitFormData.append('message', messageValue);

    console.log('📝 Form submission data (API payload):', {
      full_name: nameValue,
      email: emailValue,
      mobile: mobileClean,
      subject: finalSubject,
      message: messageValue
    });

    try {
      const result = await apiService.submitContact(submitFormData);
      if (result.success) {
        alert(result.message || 'Thank you for contacting us! We will get back to you within 24 hours.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          mobile: '',
          subject: '',
          message: ''
        });
      } else {
        alert(result.message || 'Error submitting form. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with us - We're here to help!</p>
        </div>
      </section>

      <div className="contact-form-wrapper">
        <div className="contact-form-header">
          <h3>Send Us A Message</h3>
          <p>Fill out the form below and we'll get back to you within 24 hours</p>
        </div>
        <form id="contact-form" className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input 
                type="text" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name" 
                required 
              />
            </div>
            <div className="form-group">
              <label>Email Id *</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address" 
                required 
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Mobile No. *</label>
              <input 
                type="tel" 
                name="mobile" 
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter 10-digit mobile number" 
                maxLength={10}
                inputMode="numeric"
                pattern="[0-9]{10}"
                required 
              />
            </div>
            <div className="form-group">
              <label>Subject</label>
              <input 
                type="text" 
                name="subject" 
                value={formData.subject}
                onChange={handleChange}
                placeholder="What is this about?" 
              />
            </div>
          </div>
          <div className="form-group">
            <label>Your Message *</label>
            <textarea 
              name="message" 
              rows="6" 
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us more about your inquiry..." 
              required
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Sending...
              </>
            ) : (
              'Send Message'
            )}
          </button>
        </form>
      </div>

      <section className="whatsapp-section section-padding bg-light">
        <div className="container">
          <div className="whatsapp-contact-banner">
            <div className="whatsapp-content">
              <i className="fab fa-whatsapp"></i>
              <div>
                <h4>Need Quick Assistance?</h4>
                <p>Connect with us on WhatsApp for instant support and quick responses</p>
              </div>
            </div>
            <a href="https://wa.me/919825555470" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
              <i className="fab fa-whatsapp"></i> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="map-section section-padding bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Find Us on Map</h2>
            <p>Visit our office for in-person consultations</p>
          </div>
          
          <div className="map-container">
            <div className="map-placeholder">
              <i className="fas fa-map-marked-alt"></i>
              <p>Ahmedabad, Gujarat - 380013</p>
              <a href="https://maps.app.goo.gl/zY3mgG8mEqexGouW7?g_st=ac" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <i className="fas fa-map-marker-alt"></i> Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;

